import React from 'react';
import PropTypes from 'prop-types';

import { Container, Divider, Placeholder } from 'semantic-ui-react';

import EventItem from './EventItem';

const EventsPage = ({ isFetching, data }) => {
  const EventPageLoader = Array.from(Array(3).keys()).map(key => (
    <div
      key={key}
      css={{
        width: '100%',
        display: 'flex',
        marginBottom: '20px',
        border: 'solid 1px #DADDDD',
        borderRadius: '10px',
      }}
    >
      <div
        css={{
          width: '100%',
          display: 'flex',
          padding: '30px',
          flex: 0.75,
        }}
      >
        <Placeholder css={{ width: 240, height: 240 }}>
          <Placeholder.Image />
        </Placeholder>
        <div
          css={{
            display: 'flex',
            flexDirection: 'column',
            flex: 1,
            marginLeft: 30,
          }}
        >
          <div
            css={{
              display: 'flex',
              flexDirection: 'column',
            }}
          >
            <Placeholder
              fluid
              css={{
                '&&&.ui.fluid.placeholder': {
                  width: 150,
                },
              }}
            >
              <Placeholder.Line />
            </Placeholder>
            <Placeholder
              fluid
              css={{
                '&&&.ui.fluid.placeholder': {
                  width: 150,
                  margin: 0,
                },
              }}
            >
              <Placeholder.Line />
            </Placeholder>
            <Placeholder
              fluid
              css={{
                '&&&.ui.fluid.placeholder': {
                  width: 150,
                  margin: 0,
                },
              }}
            >
              <Placeholder.Line />
            </Placeholder>
          </div>
          <Placeholder fluid length="very.long">
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
            <Placeholder.Line />
          </Placeholder>
          <Placeholder css={{ height: 25, width: 80 }}>
            <Placeholder.Image />
          </Placeholder>
          <Placeholder css={{ width: 130, height: 40 }}>
            <Placeholder.Image />
          </Placeholder>
        </div>
      </div>
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          background: '#F4F7F6',
          flex: 0.25,
        }}
      >
        <div
          css={{
            background: '#fff',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            width: '174px',
            height: '174px',
            borderRadius: '10px',
            border: '1px solid #E5E5E5',
            padding: '24px',
          }}
        >
          <Placeholder css={{ width: 100, borderRadius: '50%' }}>
            <Placeholder.Image />
          </Placeholder>
        </div>

        <Placeholder
          fluid
          css={{
            '&&&.ui.fluid.placeholder': {
              width: 80,
              margin: 0,
            },

            '&&&.ui.placeholder .line': {
              background: '#F4F7F6',
            },
          }}
        >
          <Placeholder.Line />
        </Placeholder>
        <Placeholder
          fluid
          css={{
            '&&&.ui.fluid.placeholder': {
              width: 60,
              margin: 0,
            },

            '&&&.ui.placeholder .line': {
              background: '#F4F7F6',
            },
          }}
        >
          <Placeholder.Line />
        </Placeholder>
      </div>
    </div>
  ));

  return (
    <Container>
      <p
        css={{
          fontSize: 32,
          color: '#6C2D8A',
          fontWeight: 700,
          marginBottom: 10,
        }}
      >
        Events
      </p>
      <Divider
        css={{
          borderColor: '#6C2D8A',
        }}
      />
      <div
        css={{
          display: 'flex',
          flexDirection: 'column',
          marginBottom: '50px',
        }}
      >
        {isFetching
          ? EventPageLoader
          : data?.map(event => <EventItem {...event} />)}
      </div>
    </Container>
  );
};

EventsPage.propTypes = {
  isFetching: PropTypes.bool.isRequired,
  data: PropTypes.arrayOf(PropTypes.array).isRequired,
};

export default EventsPage;
